import { render, staticRenderFns } from "./TaxTarBar.vue?vue&type=template&id=5b739436&scoped=true"
import script from "./TaxTarBar.vue?vue&type=script&lang=js"
export * from "./TaxTarBar.vue?vue&type=script&lang=js"
import style0 from "./TaxTarBar.vue?vue&type=style&index=0&id=5b739436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b739436",
  null
  
)

export default component.exports